// pattern: imperative-shell
import type { ApiObservation } from "../shell/api-client";
import { navigate } from "../shell/router";

export function renderObservationCard(obs: ApiObservation): HTMLElement {
	const card = document.createElement("div");
	card.className = "card";
	card.innerHTML = `
		<div class="card-header">
			<span class="plant-name">${esc(obs.plant_name)}</span>
			<span class="stage-pill stage-${obs.stage}">${obs.stage}</span>
		</div>
		<div class="location-badge">${esc(obs.location_name)}</div>
		${obs.notes ? `<div class="observation-notes">${esc(obs.notes)}</div>` : ""}
	`;

	card.style.cursor = "pointer";
	card.addEventListener("click", () => navigate(`edit/${obs.id}`));

	return card;
}

function esc(s: string): string {
	const el = document.createElement("span");
	el.textContent = s;
	return el.innerHTML;
}
